export function firstNameOf(user: { name?: string; email?: string } | null): string {
  if (!user) return 'there';
  const name = user.name?.trim();
  if (name) {
    const first = name.split(/\s+/)[0];
    if (first) return first;
  }
  const email = user.email?.trim() ?? '';
  if (email) {
    const local = email.split('@')[0] ?? '';
    if (local) return local.charAt(0).toUpperCase() + local.slice(1);
  }
  return 'there';
}
